import "./style.css";

export const BtnSearch = (props) => {
	const isSubmitting = props.isSubmitting;

	return (
		<button type="submit" className="btn btn-primary d-flex gap-2" disabled={isSubmitting}>
			{!isSubmitting ? (
				"Pesquisar"
			) : (
				<>
					Pesquisando
					<div>
						<span
							className="spinner-grow custom-spinner spinner-grow-sm text-color me-2"
							role="status"
						></span>
						<span
							className="spinner-grow custom-spinner spinner-grow-sm text-color me-2"
							role="status"
						></span>
					</div>
				</>
			)}
		</button>
	);
};
